import * as Models from "../Models";
import * as Common from "../Common/modules";

export interface IUpdatePaymentMethodApiClient {
    getUpdatePaymentMethodSearchResults(updatePaymentMethodSearchRequest: Models.UpdatePaymentMethod.UpdatePaymentMethodSearchResult.IUpdatePaymentMethodSearchRequest): ng.IPromise<any>;
    getCustomerDetailsForUpdatePaymentMethod(updatePaymentInformationCustomerDetailRequest: Models.UpdatePaymentMethod.UpdatePaymentMethodSearchResult.UpdatePaymentInformationCustomerDetailRequest): ng.IPromise<any>;
    submitUpdatePaymentInformation(updatePaymentInformationRequest: Models.UpdatePaymentMethod.UpdatePaymentMethodSearchResult.UpdatePaymentInformationRequest): ng.IPromise<any>;
}

export class UpdatePaymentMethodApiClient implements IUpdatePaymentMethodApiClient {
    public prefix: string;

    public static $inject = ['igs.apiClientService'];

    constructor(private igsApiClientService: Common.ApiClientService.Igs.Common.IApiClientService) {
        this.prefix = "UpdatePaymentMethod";
    }

    getUpdatePaymentMethodSearchResults = (updatePaymentMethodSearchRequest: Models.UpdatePaymentMethod.UpdatePaymentMethodSearchResult.IUpdatePaymentMethodSearchRequest): angular.IPromise<any> => {
        var url = `${this.prefix}/GetUpdatePaymentMethodSearchResults`;
        return this.igsApiClientService.post(url, updatePaymentMethodSearchRequest);
    }

    getCustomerDetailsForUpdatePaymentMethod = (updatePaymentInformationCustomerDetailRequest: Models.UpdatePaymentMethod.UpdatePaymentMethodSearchResult.UpdatePaymentInformationCustomerDetailRequest): ng.IPromise<any> => {
        var url = `${this.prefix}/GetUpdatePaymentMethodCustomerDetails`;
        return this.igsApiClientService.post(url, updatePaymentInformationCustomerDetailRequest);
    }

    submitUpdatePaymentInformation = (updatePaymentInformationRequest: Models.UpdatePaymentMethod.UpdatePaymentMethodSearchResult.UpdatePaymentInformationRequest): ng.IPromise<any> => {
        return this.igsApiClientService.post(`${this.prefix}/UpdatePaymentMethod`, updatePaymentInformationRequest);
    }
}
